import { render, staticRenderFns } from "./settlement-board.vue?vue&type=template&id=008a1e9b&scoped=true&"
import script from "./settlement-board.vue?vue&type=script&lang=js&"
export * from "./settlement-board.vue?vue&type=script&lang=js&"
import style0 from "./settlement-board.vue?vue&type=style&index=0&id=008a1e9b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008a1e9b",
  null
  
)

export default component.exports